(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xain-collection-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xain-collection-description')) {
    customElements.define('xain-collection-description', class extends HTMLElement {
      connectedCallback() {
        this.disclosure = this.querySelector('details');
        this.mobileQuery = window.matchMedia('(max-width: 767.98px)');
        this.mobileExpanded = false;
        this.onViewportChange = () => {
          this.disclosure.open = this.mobileQuery.matches ? this.mobileExpanded : true;
        };
        this.onToggle = () => {
          if (this.mobileQuery.matches) this.mobileExpanded = this.disclosure.open;
        };
        this.disclosure.addEventListener('toggle', this.onToggle);
        this.mobileQuery.addEventListener('change', this.onViewportChange);
        this.onViewportChange();
      }

      disconnectedCallback() {
        this.disclosure.removeEventListener('toggle', this.onToggle);
        this.mobileQuery.removeEventListener('change', this.onViewportChange);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xain-product-assurance"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-xain-open-details]');
    if (!link) return;
    const details = document.getElementById(link.dataset.xainOpenDetails);
    if (details?.tagName === 'DETAILS') details.open = true;
  });
  } catch(e) { console.error(e); }
})();

})();
